import { useAppSelector } from "../../../../../../../redux";
import { ImageContentProps } from "./imageContent";

export const useGetPostImages = ({
  postId,
}: ImageContentProps.UseGetPostImages) => {
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const post = processed_posts[postId];
  if (!post) return [];
  if (!post.media) return [];
  if (!post.media.images) return [];
  return post.media.images;
};
